import { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";

const useProducts = () => {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const productsRef = ref(db, "products");
        const unsubscribe = onValue(productsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const loadedProducts = Object.keys(data).map((key) => ({
                    id: key,
                    ...data[key]
                }));
                setProducts(loadedProducts.reverse());
            } else {
                setProducts([]);
            }
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    return { products, isLoading };
};

export default useProducts;